import { render, staticRenderFns } from "./PkgRiskItemList.vue?vue&type=template&id=032cfe48&"
import script from "./PkgRiskItemList.vue?vue&type=script&lang=js&"
export * from "./PkgRiskItemList.vue?vue&type=script&lang=js&"
import style0 from "./PkgRiskItemList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PkgRiskItemList.vue"
export default component.exports